import React from 'react';
import { translate } from '@utils/i18n';
const namespace = 'features.dashboards.inspection_assistant_insights_v2';
function ComingSoonPlaceholder() {
    return (React.createElement("div", { className: "coming-soon-placeholder" },
        React.createElement("p", null, translate('coming_soon', { namespace }))));
}
export default ComingSoonPlaceholder;
